<template>
  <div>
    <div :class="$style.catchAll" @click="handleCatchAll"></div>
    <div :class="$style.wrapper">
      <TweenMax />
      <WinWheel />
      <canvas
        id="canvas"
        :class="$style.canvas"
        :width="canvasSize"
        :height="canvasSize"
        :style="{
        height: `${canvasSize}px !important`,
        width: `${canvasSize}px !important`
      }"
      >
        <p>
          Sorry, your browser doesn't support canvas. Please try another.
        </p>
      </canvas>
      <div :class="$style.wheel2"></div>
      <div :class="$style.wheel">
        <div :class="$style.pin">
          <b-img
              :src="require('../assets/pin.png')"
              fluid
            />
        </div>
        <div :class="$style.topText">
          <span>ARE YOU</span>
          <span><strong>FEELING LUCKY</strong></span>
          <span>TODAY?</span>
        </div>
        <div :class="$style.spinButtonWrapper">
          <div class="spinButtonBorder ">
              <div
                :class="[
                'spinButtonBorder',
                'signalCarousel',
                $style.spinButtonBorder
              ]"
                fluid
              />
          </div>
        <div :class="$style.catchAll" @click="handleCatchAll"></div>
      </div>
      <div :class="$style.spinButtonWrapper">
        <div class="spinButton" data-stop-spin-on-leave="true">
            <b-img
              @mouseover="hover = true"
              @mouseleave="hover = false"
              @click="startSpin"
              :class="[
              'spinButton',
              $style.spinButton,
            ]"
              :src="pictureOnHover"
              fluid
            />
        </div>
        <div :class="$style.catchAll" @click="handleCatchAll"></div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import TweenMax from './Scripts/TweenMax'
import WinWheel from './Scripts/WinWheel'

Vue.use(VueCookies)

export default {
  name: 'TheWinWheel',
  components: {
    WinWheel,
    TweenMax
  },
  data () {
    return {
      automaticallyStartSpinTimer: null,
      canvasSize: null,
      outerWheelImage: 470,
      innerWheelImage: 310,
      theOuterWheel: null,
      theInnerWheel: null,
      isSpinning: false,
      finishedCount: 0,
      winType: null,
      isWin: false,
      isPulsing: true,
      pictureStatic: require("../assets/button-spin.png"),
      pictureHover: require("../assets/button-hover.png"),
      hover: false
    }
  },
  methods: {
    handleCatchAll () {
      this.startSpin()
    },
    getCenterForSegment (theWheel, segmentNumber) {
      let stopAngle = 0

      if (segmentNumber) {
        if (typeof theWheel.segments[segmentNumber] !== 'undefined') {
          const { startAngle } = theWheel.segments[segmentNumber]
          const { endAngle } = theWheel.segments[segmentNumber]
          const range = (endAngle - startAngle)

          if (range > 0) {
            stopAngle = Math.floor(startAngle + range / 2)
          }
        }
      }

      return stopAngle
    },
    calculateWin () {
      // 8 200% bonus   25 spins
      // 7 175% bonus   15 spins
      // 6 125% bonus   10 spins
      // 5 no bonus   try again
      // 4 275% bonus   50 spins
      // 3 260% bonus   40 spins
      // 2 250% bonus  35 spins
      // 1 try again    no spins
      const number = Math.floor(Math.random() * 100)

      if (number >= 0 && number <= 70) { this.winType = 1; return [2, 2] }
      if (number > 70 && number <= 80) { this.winType = 2; return [3, 6]  }
      if (number > 80 && number <= 90) { this.winType = 3; return [4, 1]  }
      if (number > 90 && number <= 100) { this.winType = 4; return [1, 1]  }

      this.winType = 5
      return [2, 7]
    },
    startInfinitySpin (outerAngle = 0, innerAngle = 0) {
      this.theOuterWheel.stopAnimation(false)
      this.theOuterWheel.rotationAngle = outerAngle
      this.theOuterWheel.draw()
      this.theInnerWheel.rotationAngle = innerAngle
      this.theInnerWheel.draw(false)

      this.theOuterWheel.animation.repeat = -1
      this.theOuterWheel.animation.type = 'spinOngoing'
      this.theOuterWheel.animation.duration = 70
      this.theOuterWheel.animation.spins = 1

      this.theInnerWheel.animation.repeat = -1
      this.theInnerWheel.animation.type = 'spinOngoing'
      this.theInnerWheel.animation.duration = 70
      this.theInnerWheel.animation.spins = 1

      this.theInnerWheel.startAnimation()
      this.theOuterWheel.startAnimation()
    },
    startSpin () {
      if (this.automaticallyStartSpinTimer) {
        clearTimeout(this.automaticallyStartSpinTimer)
        this.automaticallyStartSpinTimer = null
      }
      this.isWin = false
      this.isSpinning = true
      this.isPulsing = false
      this.finishedCount = 0

      const [outer, inner] = this.calculateWin()

      this.theOuterWheel.animation = {
        clearTheCanvas: true,
        duration: 5,
        repeat: 0,
        spins: 5,
        easing: 'Power4.easeOut',
        stopAngle: this.getCenterForSegment(this.theOuterWheel, outer),
        type: 'spinAndBack',
        callbackFinished: this.spinFinished,
        callbackAfter: this.renderInnerWheel
      }

      this.theInnerWheel.animation = {
        clearTheCanvas: true,
        direction: 'anti-clockwise',
        duration: 5,
        repeat: 0,
        spins: 5,
        easing: 'Power4.easeOut',
        stopAngle: this.getCenterForSegment(this.theInnerWheel, inner),
        type: 'spinAndBack',
        callbackFinished: this.spinFinished,
        callbackAfter: this.renderOuterWheel
      }

      this.theOuterWheel.rotationAngle = 0
      this.theOuterWheel.draw()
      this.theInnerWheel.rotationAngle = 0
      this.theInnerWheel.draw(false)

      this.theInnerWheel.startAnimation()
      this.theOuterWheel.startAnimation()
    },
    initOuterWheel () {
      // eslint-disable-next-line no-undef
      this.theOuterWheel = new Winwheel({
        numSegments: 8,
        responsive: true,
        drawMode: 'image',
        rotationAngle: 1,
        outerRadius: 235,
        innerRadius: 120,
        segments: [
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' }
        ],
        animation: {
          type: 'spinToStop',
          duration: 4,
          spins: 6,
          callbackFinished: this.spinFinished,
          callbackAfter: this.renderInnerWheel
        }
      })

      const image = new Image()
      image.onload = () => {
        this.theOuterWheel.wheelImage = image // Make wheelImage equal the loaded image object.
        this.theOuterWheel.draw(true) // Also call draw function to render the wheel.
      }

      // Set the image source, once complete this will trigger the onLoad callback (above).
      image.src = 'img/wheel-1.png';
      image.width = this.outerWheelImage;
      image.height = this.outerWheelImage;
    },
    initInnerWheel () {
      // eslint-disable-next-line no-undef
      this.theInnerWheel = new Winwheel({
        numSegments: 8,
        responsive: true,
        drawMode: 'image',
        rotationAngle: -1,
        outerRadius: 120,
        segments: [
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' },
          { text: 'Prize 1' }
        ],
        animation: {
          type: 'spinToStop',
          direction: 'anti-clockwise',
          duration: 5,
          spins: 8,
          callbackFinished: this.spinFinished,
          callbackAfter: this.renderOuterWheel
        }
      })

      // Create new image object in memory.
      const firstImg = new Image()

      // Create callback to execute once the image has finished loading.
      firstImg.onload = () => {
        this.theInnerWheel.wheelImage = firstImg// Make wheelImage equal the loaded image object.
        this.theInnerWheel.draw() // Also call draw function to render the wheel.
      }

      // Set the image source, once complete this will trigger the onLoad callback (above).
      firstImg.src =  `img/wheel-2.png`
      firstImg.width = this.innerWheelImage;
      firstImg.height = this.innerWheelImage;
    },
    renderInnerWheel () {
      this.theInnerWheel.draw(false)
    },
    renderOuterWheel () {
      this.theOuterWheel.draw(false)
    },
    spinFinished () {
      if (this.isSpinning) {
        this.finishedCount = this.finishedCount + 1
        if (this.finishedCount === 2) {
          this.isWin = true
          if (this.winType) {
            setTimeout(() => {
              this.$emit('on-win', this.winType)
            }, 100)
            this.isSpinning = false
          } else {
            setTimeout(() => {
              this.isWin = false
            }, 1000)
          }
        }
      }
    },
    calculateCanvasSize () {
      const screenWidth = document.documentElement.clientWidth
      let size = 320
      if (screenWidth >= 2000) {
        size = 850
      } else if (screenWidth >= 1200) {
        size = 750
      } else if (screenWidth >= 992) {
        size = 750
      } else if (screenWidth >= 768) {
        size = 620
      } else if (screenWidth >= 576) {
        size = 580
      }else if (screenWidth >= 400) {
        size = 410
      }
      return size
    },
    calculateOuterWheelImage () {
      const screenWidth = document.documentElement.clientWidth
      let size = 297
      if (screenWidth >= 2000) {
        size = 720
      } else if (screenWidth >= 1200) {
        size = 636
      } else if (screenWidth >= 992) {
        size = 630
      } else if (screenWidth >= 768) {
        size = 520
      } else if (screenWidth >= 576) {
        size = 490
      }else if (screenWidth >= 400) {
        size = 350
      }
      return size
    },
    calculateInnerWheelImage () {
      const screenWidth = document.documentElement.clientWidth
      let size = 310
      if (screenWidth >= 2000) {
        size = 750
      } else if (screenWidth >= 1200) {
        size = 650
      } else if (screenWidth >= 992) {
        size = 650
      } else if (screenWidth >= 768) {
        size = 520
      } else if (screenWidth >= 576) {
        size = 500
      }else if (screenWidth >= 400) {
        size = 350
      }
      return size
    },
    onResize () {
      this.redrawWheels()
    },
    redrawWheels () {
      const currentCanvasSize = this.calculateCanvasSize()
      if (currentCanvasSize !== this.canvasSize) {
        this.canvasSize = currentCanvasSize
        this.outerWheelImage = this.calculateOuterWheelImage()
        this.innerWheelImage = this.calculateInnerWheelImage()
        setTimeout(() => {
          this.initOuterWheel()
          this.initInnerWheel()
          this.theOuterWheel.rotationAngle = 0
          this.theInnerWheel.rotationAngle = 0
          this.theOuterWheel.draw()
          this.theInnerWheel.draw(false)
        }, 150)
      } else {
        setTimeout(() => {
          this.theOuterWheel.draw()
          setTimeout(() => {
            this.theInnerWheel.draw(false)
          }, 50)
        }, 100)
      }
    }
  },
  computed: {
    pictureOnHover () {
      if (this.hover == true) {
        return this.pictureHover
      } else {
        return this.pictureStatic
      }
    }
  },
  updated () {},
  mounted () {
    window.addEventListener('resize', this.onResize)
    this.redrawWheels()
    setTimeout(() => {
      this.startInfinitySpin()
    }, 300)

    setTimeout(() => {
      // eslint-disable-next-line no-undef
    }, 350)

    this.automaticallyStartSpinTimer = setInterval(this.startSpin, 8000)
  },
  created () {},
  beforeDestroy () {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>

<style module lang="scss">
  .wrapper {
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: center;
    min-width: 350px;
    transition: all .2s ease-in-out;
    transform: scale(1);
    &:before {
      position: absolute;
      pointer-events: none;
      content: "";
      background-size: cover;
      bottom: 0;
      left:0;
      z-index: -1;
    }
    .pin{
      position: absolute;
      top: 20px;
      width: 100%;
      display: flex;
      justify-content: center;
      z-index: 2;
      img{
        width: 100%;
        max-width: 100px;
      }
    }
    .topText {
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: center;
      color: white;
      align-items: center;
      font-size: 24px;
      flex-direction: column;
      gap: 5px;
      top: -12%;
      font-size: 27px;
      font-weight: 400;
      line-height: 27px;
    }

    .wheel {
      background: url('../assets/wheel.png') no-repeat center,
      url('../assets/base.png') no-repeat bottom center;
      background-size: contain;
      position: absolute;
      bottom: 0;
      width: 85%;
      height: 100%;
    }
    .wheel2 {
      background: url('../assets/wheel-2.png') no-repeat center;
      background-size: contain;
      position: absolute;
      bottom: 0;
      width: 85%;
      height: 100%;
      z-index: 1;
      animation-name: FadeInOut;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
      animation-duration: 0.5s;
      animation-direction: alternate;
        @keyframes FadeInOut {
      0% { opacity:1; }
      45% {  opacity:1; }
      55% { opacity:0; }
      100% { opacity:0; }
    }
    }
    .winWheel {
      background: url('../assets/wheel-win-background.png') no-repeat center;
      background-size: contain;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 80%;
      height: 100%;
    }
    .spinButtonWrapper {
      z-index: 10;
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .spinButton {
        cursor: pointer;
        max-height: 100px;
        max-width: 100px;
        border-radius: 50%;
      }
      .spinButtonBorder {
        cursor: pointer;
        width: 150px;
        height: 150px;
        max-height: 150px;
        max-width: 150px;
        border-radius: 50%;
      }
    }
  }
  .catchAll {
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    cursor: pointer;
  }
  @media (max-width:400px) {
    .wrapper {
      transform: scale(1.1) translateY(50px);
      &:before {
        width: 150%;
        height: 80%;
        top: 10%;
        left: -25%;
      }
      .pin{
      top: -5px;
      img{
        width: 100%;
        max-width: 50px;
      }
    }
    .topText {
      font-size: 22px;
        top: -95px;
      }
      .spinButtonWrapper{
      .spinButton {
        max-height: 50px;
        max-width: 50px;
      }
      .spinButtonBorder {
        width: 65px;
        height: 65px;
      }
    }
    }
  }
  @media (min-width:400px) and (max-width: 575.98px) {
    .wrapper {
      transform: scale(1.1) translateY(50px);
      &:before {
        width: 150%;
        height: 80%;
        top: 10%;
        left: -25%;
      }

      .pin{
      top: 20px;
      img{
        width: 100%;
        max-width: 50px;
      }
    }
    .topText {
        top: -80px;
      }
      .spinButtonWrapper{
      .spinButton {
        max-height: 50px;
        max-width: 50px;
      }
      .spinButtonBorder {
        width: 80px;
        height: 80px;
      }
    }
      .logo {
        img {
          width: 45vw;
          max-width: 170px;
        }
      }
    }
  }
  @media (min-width: 576px) and (max-width: 767.98px) {
    .wrapper {
      transform: scale(1) translateY(50px);
      &:before {
        width: 150%;
        height: 90%;
        left:-25%;
      }
      .pin{
      top: 20px;
      img{
        width: 100%;
        max-width: 70px;
      }
    }
      .logo {
        img {
          max-width: 200px;
        }
      }
      .topText {
        top: -70px;
      }
      .spinButtonWrapper{
      .spinButton {
        max-height: 80px;
        max-width: 80px;
      }
      .spinButtonBorder {
        width: 120px;
        height: 120px;
      }
    }
    }
  }

  @media (min-width: 768px) and (max-width: 991.98px) {
    .wrapper {
      transform: scale(1) translateY(50px);
      .topText {
        top: -55px;
      }
      .pin{
      top: 30px;
      img{
        width: 100%;
        max-width: 70px;
      }
    }
      .spinButtonWrapper{
      .spinButton {
        max-height: 80px;
        max-width: 80px;
      }
      }
      .spinButtonBorder {
        width: 120px;
        height: 120px;
      }
    }
    }

  @media (min-width: 992px) and (max-width: 1199.98px) {
    .wrapper {
      transform: scale(0.9) translateY(50px);
    }
  }

  @media (min-width: 1200px) and (max-width: 1999.98px) {
    .wrapper {
      transform: scale(0.95) translateY(65px);
    }
  }
  @media (min-width: 2000px) {
    .wrapper {
      transform: scale(1.1) translateY(65px);
      &:before {
        width: 160%;
        height: 100%;
        top: 0;
        left: -30%;
      }
    }
  }
</style>

<style lang="scss">
  .spinButton {
    z-index: 10;
    border-radius: 50%;
    transition: all .3s ease;
  }
  .spinButtonBorder {
    z-index: 10;
    border-radius: 50%;
    transition: all .3s ease;
      &.signalCarousel {
      background-image: url('../assets/animation.png'); background-size: cover;
      animation: playX 0.7s steps(12) infinite
    }
  }
</style>

<style>
  @keyframes playX {
      from {background-position-x: 0;}
      to {background-position-x: 100%;}
      }
</style>


